import baseOverrides from './../baseOverrides'

export default baseOverrides
